var map = {
	"./bankvault.png": "45a7",
	"./brainstorm.png": "1aca",
	"./faces.png": "5b3c",
	"./shopping.png": "59a9",
	"./timemachine.png": "53b8",
	"./vocabguru.png": "cced"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "697f";